/** Registro operacional oficial. Códigos de checkout não são IDs de produto. */
export type ProdutoBlackfeo = {
  id: string; nome: string; linha: "posA" | "posB" | "cert" | "star" | "agente";
  lp: string | null; checkouts: { nome: string; codigo: string; productId?: string; parcelasContrato?: number; tag?: string }[];
};
const host = "https://fisioemortopedia.com.br";
export const CATALOGOS_BLACKFEO = [
  { id: "catalogo-geral", nome: "Catálogo principal", url: `${host}/blackfeo` },
  { id: "catalogo-entregas", nome: "Catálogo de entregas", url: `${host}/blackfeo-entregas` },
] as const;
export const PRODUTOS_BLACKFEO: ProdutoBlackfeo[] = [
  ...[
    ["orto", "Ortopedia", "pos-orto", "3109939", "3109940", "60E2E8Q3W3", "E0DK6ODR91", "aluno-orto-geral"],
    ["dor", "Dor", "pos-dor", "3109955", "3109956", "Q9N25BN101", "D0R8A7P69Y", "aluno-dor-geral"],
    ["esporte", "Esporte", "pos-esporte", "3109958", "3109959", "G96R1DJQW1", "89AXQE7G0D", "aluno-esporte-geral"],
    ["geronto", "Gerontologia", "pos-geronto", "3109962", "3109963", "1W32Z6OG92", "60E2E8Z3W3", "aluno-geronto-geral"],
    ["trauma", "Traumatologia", "pos-traumato", "3109968", "3109969", "39YNDV54WO", "E9OGOY6KWB", "aluno-trauma-geral"],
    ["prescricao", "Prescrição", "pos-prescricao", "3109971", "3109972", "R9JXJ6QE0X", "KW8ZKYJO01", "aluno-prescricao-geral"],
  ].map(([id, nome, dominio, unica, assin, codigoU, codigoA, tag]) => ({
    id: `pos-${id}`, nome: `Pós ${nome}`, linha: (id === "trauma" || id === "prescricao" ? "posB" : "posA") as "posA" | "posB",
    lp: `https://${dominio}.fisioemortopedia.com.br/`,
    checkouts: [{ nome: "Única", codigo: codigoU, productId: unica, tag }, { nome: "Assinatura", codigo: codigoA, productId: assin, parcelasContrato: id === "trauma" || id === "prescricao" ? 12 : 15, tag }],
  })),
  ...[
    ["lombar", "Coluna Lombar", "G92VQY5Z9E", "2464177"],
    ["cervical", "Coluna Cervical", "2439321", "2439321"],
    ["eletro", "Agentes Eletrofísicos", "VWGZ1J2P07", "2662106"],
    ["ombro", "Ombro", "D0RAA28B9Y", "2774232"],
    ["tornozelo", "Tornozelo e Pé", "69KAZ55A0O", "2862776"],
    ["joelho", "Joelho", "1W32DY3592", "3013662"],
    ["quadril", "Quadril", "G96RR16QW1", "3115382"],
  ].map(([id, nome, codigo, productId]) => ({ id: `cert-${id}`, nome: `Certificação ${nome}`, linha: "cert" as const, lp: `${host}/certificacao-${id}`, checkouts: [{ nome: "Certificação avulsa", codigo, productId }] })),
  { id: "combo-cert", nome: "Combo · 7 certificações", linha: "cert", lp: null, checkouts: [{ nome: "Combo completo", codigo: "E0DK7ZYE91", productId: "3141216" }] },
  { id: "star", nome: "STAR Cursos", linha: "star", lp: `${host}/star`, checkouts: [
    { nome: "1 ano", codigo: "1675886", productId: "1675886" },
    { nome: "3 anos", codigo: "1923333", productId: "1923333" },
    { nome: "Vitalícia", codigo: "1716431", productId: "1716431" },
  ] },
  { id: "agente", nome: "Agente IA", linha: "agente", lp: `${host}/agente-raciocinio`, checkouts: [{ nome: "Agente IA", codigo: "G96165PYW1", productId: "2874682" }] },
];
export function urlCheckoutBlackfeo(codigo: string, assinatura = false) {
  return `https://chk.eduzz.com/${codigo}?cupom=BLACKFEO&df=1${assinatura ? "" : "&pf=1"}`;
}
/** Entregas implementadas/conferidas; não misturar com tarefas externas por confirmar. */
export const CONCLUIDOS_BLACKFEO = [
  ["catalogos", "Dois catálogos compartilhados, liberados para teste; entregas com faixa de material no e-mail"],
  ["lps-cert", "Sete certificações com ofertas BLACKFEO e checkout embutido"],
  ["lps-outros", "STAR e Agente personalizados; combo extra direto ao checkout"],
  ["previa-privada", "Prévia por ?preview=1, persistência na visita e links do catálogo até a virada"],
  ["checkout-links", "24 links oficiais, cupons e IDs conferidos; contratos 15x/12x confirmados pelo Tarcísio"],
  ["combo-id", "Combo confirmado: produto 3141216 / checkout E0DK7ZYE91"],
  ["dominios-redirecionar", "Códigos Wix publicados pelo Tarcísio; STAR e Lombar testados preservando UTMs"],
  ["virada-programar", "Virada automática implementada para site/E-FISIO, catálogos e entregas em 04/11 00h"],
  ["preservar-dobro", "Ofertas Black em Dobro, alunos e CBFEO preservadas; divulgação pública passa ao catálogo"],
] as const;

export const CHECKLIST_BLACKFEO = {
  "Antes da virada · equipe / validação": [
    ["lps-pos", "Equipe Wix: aplicar BLACKFEO nas seis pós (preços, IDs gerais, pré-checkouts, banner e pop-up); o black-wix.js atual ainda encerra a divulgação antiga"],
    ["checkout-bumps", "Equipe Eduzz: confirmar e ativar os order bumps propostos; links e preços base já conferidos"],
    ["compras-teste", "Equipe: concluir compra controlada, acesso ao produto e tags RD/Eduzz Connect; aberturas sem pagamento já testadas"],
    ["publicacao-final", "Publicar esta revisão e conferir prévias/capturas no domínio oficial antes de 04/11"],
    ["externos", "Equipe: trocar AlpaClass, Instagram, Beacons, e-mails e automações para o catálogo em 04/11 00h"],
    ["trafego", "Gestor: revisar Meta, Google e ManyChat, destino /blackfeo e atribuição"],
    ["crm-rastreio", "Comercial: usar afiliado conhecido ou utm_source=CRM + utm_medium com nome da vendedora nas vendas Dobro; conciliar vendas externas separadamente"],
  ],
  "Validação na virada · 04/11": [
    ["virada-validar", "Conferir domínio oficial: banners/catálogo, preços, entregas e links sem preview=1"],
    ["fontes", "Conciliar pagamentos e contratos Eduzz com dashboard e tags de compradores; conferir Dobro somente CRM"],
  ],
  "Encerramento · 01/12 00h": [
    ["retorno", "Equipe Wix: voltar pós ao LOTEPROMO / LOTEPROMOASS, única com np=10; ofertas Lovable têm retorno automático"],
    ["encerrar-externos", "Desativar anúncios e chamadas BLACKFEO externas; validar restauração automática do site"],
    ["relatorio", "Fechar relatório por frente, ticket e mix sem apagar produtos, leads ou histórico"],
  ],
} as const;